// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"ac52b57a","292":"ee6509d2","385":"6dba7398","406":"63b876e3","409":"787d3cc2","541":"e92ef95f","618":"01e134e8","738":"bda229c7","774":"32fb70dc","850":"01ca5c54","996":"de81a496"}[chunkId] + ".chunk.js";
};